import { BaseMemberSession } from "./member";

export class Authenticator {
    email: string;
    phoneNumber: string;
    enrollCheckoutCodeId: number;
    isVerificationSent: boolean;
    isCodeVerified: boolean;
    retryRequest: boolean;
    returnMessage: string;
}

export class AuthenticatorRequest {
    email: string;
    systemNumber: string;
    phoneNumber: string;
    verifyCode: string;
    authenticatorTypeValue: string;
    verificationTypeValue: string;
}

export class AuthenticatorQR {
    qrCodeUrl: string;
    manualEntryKey: string;
    verifyCode: string;
}

export class AuthenticatorInfo {
    accessToken: string;
    refreshToken: string;
    cellPhoneNumber: string;
    phoneNumber: string;
    email: string;
    message: string;
    isPhoneConfigured: boolean;
    isQRConfigured: boolean;
    requireOnboarding: boolean;

    constructor() {
        this.accessToken = null;
        this.refreshToken = null;
        this.cellPhoneNumber = null;
        this.phoneNumber = null;
        this.email = null;
        this.message = null;
        this.isPhoneConfigured = false;
        this.isQRConfigured = false;
        this.requireOnboarding = false;
    }
}

export class MultiFactorAuthenticator extends AuthenticatorInfo {
    adminDirectSystem: string;
    agentCity: string;
    agentState: string;
    isMember: boolean;

    constructor() {
        super();
        this.adminDirectSystem = null;
        this.agentCity = null;
        this.agentState = null;
        this.isMember = false;
    }
}